import * as types from '../actiontypes';
export function getConfigurations(url, resource) {
	return {
		type: types.GET_CONFIGURATIONS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}
